import React, { useEffect, useState } from "react";
import {
  QuestionConfigDetailDto,
  QuestionConfigTranslationDto,
} from "@green0meter/api-client";

import { StyledTextField } from "../../QuestionTypeEditor.styled";

import { useQuestionEditorStore } from "@components/main/questions/QuestionEditor";

interface EmailInput {
  questionConfig: QuestionConfigDetailDto;
  setQuestionConfig: (questionConfig: QuestionConfigDetailDto) => void;
}

const EmailInput: React.FC<EmailInput> = ({ questionConfig, setQuestionConfig }) => {
  const { language } = useQuestionEditorStore();
  const [translation, setTranslation] = useState<QuestionConfigTranslationDto>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (questionConfig) {
      setQuestionConfig({
        ...questionConfig,
        translations: questionConfig.translations.map((translation) =>
          translation.language === language
            ? { ...translation, placeholder: e.target.value }
            : translation,
        ),
      });
    }
  };

  useEffect(() => {
    if (questionConfig) {
      const currentTranslation = questionConfig.translations.find(
        (translation) => translation.language === language,
      );

      setTranslation(currentTranslation);
    }
  }, [questionConfig, language]);

  return (
    <StyledTextField
      value={translation?.placeholder || ""}
      onChange={handleChange}
      placeholder="Email"
      variant="filled"
      fullWidth
    />
  );
};

export default EmailInput;
